import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DynamicObjectType } from 'types/commons';

interface ViewStocksTypes {
  record?: DynamicObjectType;
}

export default function ViewStocks({ record }: ViewStocksTypes) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = () => {
    const searchParams = new URLSearchParams();
    searchParams.set(
      'filters',
      JSON.stringify(
        [
          {
            condition: 'and',
            key: 'locationCode',
            operator: 'contL',
            value: record?.id,
          },
        ],
        null,
        0,
      ),
    );
    navigate(`/inventory?${searchParams.toString()}`);
  };

  return (
    <Button disabled={!record?.id} type="link" onClick={handleClick}>
      <div className="text-sm text-primary">
        {t('mores.locations.viewStocks')}
      </div>
    </Button>
  );
}
